import { LocaleType } from "../model/types";

export const ru: LocaleType = {
  SIDEBAR: {
    MAIN: "Главная",
    ADMIN_PERMISSIONS: "Административные права",
  },
  ADMIN: {
    USERS_WITH_ACCESS: "Пользователи с доступом",
    PERMISSIONS: "Права доступа",
    PERMISSION_USERS: "Пользователи с правами доступа",
    ADD_USER: "Добавить пользователя",
    REMOVE_USER: "Удалить пользователя",
    SEARCH_USERS: "Поиск пользователей",
    USERS: "Пользователи",
    USERS_WITH_PERMISSION: "Пользователи с правами доступа: ",
    PERMISSIONS_MANAGEMENT: "Управление правами доступа",
    CURRENT_USERS: "Текущие пользователи",
    NO_USERS_WITH_PERMISSION: "Нет пользователей с правами доступа",
    SELECT_PERMISSION: "Выберите право доступа",
    ALL_USERS_WITH_ACCESS: "Все пользователи с доступом",
    SEARCH_RESULTS: "Результаты поиска",
  },
  ACTIONS: {
    SEARCH: "Поиск",
    ADD: "Добавить",
    REMOVE: "Удалить",
    CONFIRM: "Подтвердить",
    BACK: "Назад",
  },
  AUTH: {
    VERIFY_CODE: "Введите код",
    ENTER_SMS_CODE: "Для подтверждения номера, введите код из СМС, отправленный на номер:",
    RESEND_CODE_TIMER: "Отправить повторно через {{seconds}} сек.",
    RESEND_CODE: "Отправить код повторно",
  },
  PROFILE: {
    USER: "Пользователь",
  },
} as const;
